import clsx from 'clsx';
import * as styles from './styles.css';
import { JSX } from 'react';

interface IResultModalContentProps {
  title: string;
  imageClass: string;
  btn: JSX.Element;
  description?: string;
}

export const ResultModalContent: React.FC<IResultModalContentProps> = ({ title, imageClass, description, btn }) => {
  return (
    <div className={styles['container']}>
      <div className={clsx(styles['image'], styles[imageClass])} />
      <div className={styles['title']}>{title}</div>
      {description && <div className={styles['description']}>{description}</div>}
      <div className={styles['btn']}>{btn}</div>
    </div>
  );
};
